
import PageTitle from '@/components/shared/PageTitle/index.vue'
import AwardOne from '~/components/Base/Awards/AwardOne.vue'
import StoryOne from '~/components/Base/Stories/StoryOne.vue'
import services from '~/services'
import NewsBlockOne from '~/components/Base/News/NewsBlockOne.vue'
import meta from '~/mixins/meta'
export default {
  mixins: [meta],
  components: {
    PageTitle,
    AwardOne,
    StoryOne,
    NewsBlockOne,
  },
  asyncData({ route }) {
    const aboutUs = services.aboutUs.getAll()
    const awards = services.awards.getAll()
    const blogs = services.blogs.getAll(1)
    const meta = services.meta.getByPath(route.path)
    return {
      aboutUs,
      blogs,
      meta,
      awards,
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$route.query.blog)
        document.getElementById('blog-list').scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
    }, 250)
  },
}
